import { Button, CityState, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLocationManualAdd extends Layout {
    buttonCancel: Button;
    buttonUseThisAddress: Button;
    citystateLocation: CityState;
    panelButtons: Panel;
    sourceLocation: DataSource;
    textboxCompanyName: Textbox;
    textboxStreetName: Textbox;
}
